module.exports = __webpack_public_path__ + "static/img/68 (1).87c72ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/68 (1).jpg
// module id = BrxF
// module chunks = 0